import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ICmsPage, IContentBanner } from '../models/cms';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { IDynamicAttribute } from '../models/common.models';
import { GlueConfigurationService } from './glue-configuration.service';

@Injectable({
  providedIn: 'root',
})
export class CmsService {
  private readonly httpClient: HttpClient = inject(HttpClient);
  private readonly glueConfiguration: GlueConfigurationService = inject(GlueConfigurationService);

  glueUrl: string = this.glueConfiguration.getEndpointUrl();

  private readonly cmsPageURI: string = '/cms-pages/';
  private readonly contentBannerURI: string = '/content-banners-by-key/';

  private static handleError(error: any): Promise<any> {
    return Promise.reject(error.message || error);
  }

  getCMSPage(key: string): Observable<ICmsPage> {
    const url: string = this.glueUrl + this.cmsPageURI + key;
    return this.httpClient.get<IDynamicAttribute>(url)
      .pipe(
        map((res: IDynamicAttribute) => res.data as ICmsPage),
        catchError(CmsService.handleError),
      );
  }

  getContentBannerByKey(contentBannerKey: string): Observable<IContentBanner> {
    const url: string = this.glueUrl + this.contentBannerURI + contentBannerKey;
    return this.httpClient.get<IDynamicAttribute>(url)
      .pipe(
        map((res: IDynamicAttribute) => res.data as IContentBanner),
        catchError(CmsService.handleError),
      );
  }
}
